//*** 'READ MORE...' FEATURE IN PRODUCT PAGES ***//
document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".read-more-toggle");

  toggleButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      const wrapper = button.closest(".product__description");
      const shortDesc = wrapper.querySelector(".description-short");
      const fullDesc = wrapper.querySelector(".description-full");

      if (fullDesc.style.display === "none") {
        shortDesc.style.display = "none";
        fullDesc.style.display = "block";
        button.textContent = "Read less...";
      } else {
        shortDesc.style.display = "block";
        fullDesc.style.display = "none";
        button.textContent = "Read more...";
      }
    });
  });
});
